export const ASC = 'ASC';
export const DESC = 'DESC';

export const ZMOD_PROD_PROJECT_ID = 'zmod-prod';
export const GRATA_PROD_PROJECT_ID = 'gratasys';
export const GRATA_DEV_PROJECT_ID = 'gratasys-dev';

export const SSO_TYPE_SAML = 'SAML';
export const SSO_TYPE_OIDC = 'OIDC';

export const HTTP_STATUS = {
  forbidden: 403
};

export const SEARCH_TABLES = {
  ORGANIZATIONS: 'organizations',
  USERS: 'users',
  BOOKINGS: 'bookings',
  BUILDINGS: 'buildings',
  DELIVERY_CODES: 'delivery_codes',
  WORK_REQUESTS: 'service_requests',
  OFFERS: 'offers',
  DELIVERIES: 'deliveries',
  CARRIER_COMPANIES: 'carrier_companies'
};

export const DEFAULT_PAGINATION_COUNT = 20;
export const DEFAULT_PAGINATION_PAGE = 1;
export const DEFAULT_PAGINATION = {
  page: DEFAULT_PAGINATION_PAGE,
  limit: DEFAULT_PAGINATION_COUNT
};

export const DEFAULT_DEVICE_DOWN_NOTIFICATION_DELAY = 30;

export const NEW_NOTIFICATION_KEY = 'newNotification';
export const USER_ID_KEY = 'user_id';
export const whiteListedDomains = ['@grata.life'];

export const TIME_ZONES = new Map([
  ['AL', 'America/Chicago'],
  ['AK', 'America/Anchorage'],
  ['AS', 'Pacific/Pago_Pago'],
  ['AZ', 'America/Phoenix'],
  ['AR', 'America/Chicago'],
  ['CA', 'America/Los_Angeles'],
  ['CO', 'America/Denver'],
  ['CT', 'America/New_York'],
  ['DE', 'America/New_York'],
  ['DC', 'America/New_York'],
  ['FM', 'Pacific/Ponape'],
  ['FL', 'America/New_York'],
  ['GA', 'America/New_York'],
  ['GU', 'Pacific/Guam'],
  ['HI', 'Pacific/Honolulu'],
  ['ID', 'America/Boise'],
  ['IL', 'America/Chicago'],
  ['IN', 'America/Indiana/Indianapolis'],
  ['IA', 'America/Chicago'],
  ['KS', 'America/Chicago'],
  ['KY', 'America/New_York'],
  ['LA', 'America/Chicago'],
  ['ME', 'America/New_York'],
  ['MH', 'Pacific/Majuro'],
  ['MD', 'America/New_York'],
  ['MA', 'America/New_York'],
  ['MI', 'America/New_York'],
  ['MN', 'America/Chicago'],
  ['MS', 'America/Chicago'],
  ['MO', 'America/Chicago'],
  ['MT', 'America/Denver'],
  ['NE', 'America/Chicago'],
  ['NV', 'America/Los_Angeles'],
  ['NH', 'America/New_York'],
  ['NJ', 'America/New_York'],
  ['NM', 'America/Denver'],
  ['NY', 'America/New_York'],
  ['NC', 'America/New_York'],
  ['ND', 'America/Chicago'],
  ['MP', 'Pacific/Saipan'],
  ['OH', 'America/New_York'],
  ['OK', 'America/Chicago'],
  ['OR', 'America/Los_Angeles'],
  ['PW', 'Pacific/Palau'],
  ['PA', 'America/New_York'],
  ['PR', 'America/Puerto_Rico'],
  ['RI', 'America/New_York'],
  ['SC', 'America/New_York'],
  ['SD', 'America/Chicago'],
  ['TN', 'America/Chicago'],
  ['TX', 'America/Chicago'],
  ['UT', 'America/Denver'],
  ['VT', 'America/New_York'],
  ['VI', 'America/St_Thomas'],
  ['VA', 'America/New_York'],
  ['WA', 'America/Los_Angeles'],
  ['WV', 'America/New_York'],
  ['WI', 'America/Chicago'],
  ['WY', 'America/Denver'],
  ['AB', 'America/Edmonton'],
  ['BC', 'America/Vancouver'],
  ['MB', 'America/Winnipeg'],
  ['NB', 'America/Moncton'],
  ['NL', 'America/St_Johns'],
  ['NT', 'America/Yellowknife'],
  ['NS', 'America/Halifax'],
  ['NU', 'America/Rankin_Inlet'],
  ['ON', 'America/Toronto'],
  ['PE', 'America/Halifax'],
  ['QC', 'America/Toronto'],
  ['SK', 'America/Regina'],
  ['YT', 'America/Whitehorse']
]);

export const IGNORED_LEAK_DETECTOR_EVENTS = [
  'DeviceOffline',
  'CriticalBattery',
  'HighHumidity',
  'LowHumidity',
  'LowBattery',
  'CriticalBattery',
  'HighTemperature',
  'LowTemperature',
  'Freeze'
];

export const MODES = {
  OFF: 'off',
  AUTO: 'auto',
  COOL: 'cool',
  HEAT: 'heat',
  TEMPORARY: 'temporary'
};

export const TEMPERATURE_UNITS = {
  FAHRENHEIT: {
    label: '°F',
    value: 'Fahrenheit'
  },
  CELSIUS: {
    label: '°C',
    value: 'Celsius'
  }
};

export const THERMOSTAT_VENDORS = {
  ECOBEE: {
    label: 'Ecobee',
    vendorId: 9
  },
  HONEYWELL: {
    label: 'Honeywell',
    vendorId: 11
  },
  MYSA: {
    label: 'Mysa',
    vendorId: 20
  }
};

export const NOTIFICATION_TYPES = {
  PASSWORD_CHANGE: 0,
  // all types of service request notifications
  REQUEST_ALL: 2,
  BOOKING_CREATED: 8,
  REQUEST_COMMENT: 11,
  LOW_BATTERY: 13,
  WATER_LEAK: 14,
  HIGH_HUMIDITY: 21
};

export const isLeakDetectorNotification = (typeId) =>
  typeId === NOTIFICATION_TYPES.WATER_LEAK || typeId === NOTIFICATION_TYPES.HIGH_HUMIDITY;

export const VOPAY_ACCOUNT_STATUS = {
  ACTIVE: 'active',
  ACTIVE_BUT_MISSING_PAYMENT_METHOD: 'active but missing payment method', // building only (API-derived)
  ACTIVE_AND_PAYMENT_METHODS_SYNCED: 'active and payment methods synced', // building only (API-derived)
  ACTIVE_BUT_GRATA_BANK_FAILED: 'active but grata bank failed', // building only
  ACTIVE_BUT_MISSING_DEFAULT_BANK: 'active but missing default bank', // building only
  ACTIVE_AND_GRATA_CONFIGURED: 'active and grata configured', // building only
  APPROVED: 'approved',
  ONBOARDING: 'onboarding',
  APPLICATION_PENDING: 'application pending',
  REJECTED: 'rejected',
  DISABLED: 'disabled',
  SUSPENDED: 'suspended',
  NOT_FOUND: 'not-found'
};

export const VOPAY_SCHEDULED_PAYMENT_STATUS = {
  UPCOMING: 'upcoming',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const VOPAY_PAYMENT_STATUS = {
  SUCCESSFUL: 'successful',
  IN_PROGRESS: 'in_progress',
  PROCESSING: 'processing',
  PENDING: 'pending',
  ERROR: 'error'
};

export const VOPAY_PAYMENT_TYPE = {
  ONE_TIME: 1,
  SCHEDULED: 2,
  SPLIT: 3
};

export const PAIRING_LOCK_TYPE = {
  NO_ACTION: 0,
  PAIRING: 1,
  UNPAIRING: 2
};

export const HIGH_HUMIDITY = 65;

export const INTERCOM_NAME_SETTINGS = {
  FULL_NAME: {
    value: 'full_name',
    label: 'Full name',
    preview: (name) => name
  },
  FULL_NAME_REVERSED: {
    value: 'full_name_reversed',
    label: 'Full name reversed',
    preview: (name) => name.split(' ').reverse().join(' ')
  },
  FIRST_NAME_INITIAL: {
    value: 'first_name_initial',
    label: 'First name initial',
    preview: (name) => {
      const parts = name.trim().split(/\s+/);
      return `${parts[0].charAt(0)}. ${parts[parts.length - 1]}`;
    }
  },
  LAST_NAME_INITIAL: {
    value: 'last_name_initial',
    label: 'Last name initial',
    preview: (name) => {
      const parts = name.trim().split(/\s+/);
      return `${parts[0]} ${parts[parts.length - 1].charAt(0)}.`;
    }
  },
  INITIALS_ONLY: {
    value: 'initials_only',
    label: 'Initials only',
    preview: (name) => {
      const parts = name.trim().split(/\s+/);
      return `${parts[0].charAt(0)}. ${parts[parts.length - 1].charAt(0)}.`;
    }
  }
};

export const INTERCOM_UNIT_NAME_DISPLAY_SETTINGS = {
  NONE: {
    value: 'none',
    label: 'No display',
    preview: (name) => name
  },
  PREFIX: {
    value: 'prefix',
    label: 'Display prefix',
    preview: (name, unit) => `(${unit}) ${name}`
  },
  SUFFIX: {
    value: 'suffix',
    label: 'Display suffix',
    preview: (name, unit) => `${name} (${unit})`
  }
};
